import Alert from '@mui/material/Alert'
import { useMemberBanner } from '../api/queries'

// The administrators' announcement, pinned under the header bar on every
// page of the member app. Renders nothing while it is off -- or while the
// poll has not answered, so a failed request never costs a member the page.
//
// The message is a text node, never HTML.
export default function MemberBanner() {
  const { data: banner } = useMemberBanner()
  if (!banner) return null
  return (
    <Alert
      severity={banner.severity}
      variant="filled"
      square
      role={banner.severity === 'error' ? 'alert' : 'status'}
      sx={{ borderRadius: 0, alignItems: 'center', whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}
    >
      {banner.message}
    </Alert>
  )
}
